"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SELECTED_ITEMS_AND_EXTERNAL_INFO = exports.SET_FILTERS = exports.RESET_RESEARCH = exports.SET_OE_CATEGORY_RESEARCH = exports.SET_AVAILABILITY_RESEARCH = exports.SET_REGION_RESEARCH = exports.SET_SUBCATEGORY_NAME_RESEARCH = exports.SET_CATEGORY_NAME_RESEARCH = exports.SET_PART_TERMINOLOGY_NAME_RESEARCH = exports.SET_PART_TERMINOLOGY_ID_RESEARCH = exports.SET_SHOW_OE_PRODUCTS_ONLY = exports.SET_SELECTED_ITEMS = exports.SET_RESEARCH = exports.SET_SORT_OPTIONS = exports.SET_OE_PRODUCTS = void 0;
var SET_OE_PRODUCTS = "SET_OE_PRODUCTS";
exports.SET_OE_PRODUCTS = SET_OE_PRODUCTS;
var SET_SORT_OPTIONS = "SET_SORT_OPTIONS";
exports.SET_SORT_OPTIONS = SET_SORT_OPTIONS;
var SET_RESEARCH = "SET_RESEARCH";
exports.SET_RESEARCH = SET_RESEARCH;
var SET_SELECTED_ITEMS = "SET_SELECTED_ITEMS";
exports.SET_SELECTED_ITEMS = SET_SELECTED_ITEMS;
var SET_SHOW_OE_PRODUCTS_ONLY = "SET_SHOW_OE_PRODUCTS_ONLY";
exports.SET_SHOW_OE_PRODUCTS_ONLY = SET_SHOW_OE_PRODUCTS_ONLY;
var SET_PART_TERMINOLOGY_ID_RESEARCH = "SET_PART_TERMINOLOGY_ID_RESEARCH";
exports.SET_PART_TERMINOLOGY_ID_RESEARCH = SET_PART_TERMINOLOGY_ID_RESEARCH;
var SET_PART_TERMINOLOGY_NAME_RESEARCH = "SET_PART_TERMINOLOGY_NAME_RESEARCH";
exports.SET_PART_TERMINOLOGY_NAME_RESEARCH = SET_PART_TERMINOLOGY_NAME_RESEARCH;
var SET_CATEGORY_NAME_RESEARCH = "SET_CATEGORY_NAME_RESEARCH";
exports.SET_CATEGORY_NAME_RESEARCH = SET_CATEGORY_NAME_RESEARCH;
var SET_SUBCATEGORY_NAME_RESEARCH = "SET_SUBCATEGORY_NAME_RESEARCH";
exports.SET_SUBCATEGORY_NAME_RESEARCH = SET_SUBCATEGORY_NAME_RESEARCH;
var SET_REGION_RESEARCH = "SET_REGION_RESEARCH";
exports.SET_REGION_RESEARCH = SET_REGION_RESEARCH;
var SET_AVAILABILITY_RESEARCH = "SET_AVAILABILITY_RESEARCH";
exports.SET_AVAILABILITY_RESEARCH = SET_AVAILABILITY_RESEARCH;
var SET_OE_CATEGORY_RESEARCH = "SET_OE_CATEGORY_RESEARCH";
exports.SET_OE_CATEGORY_RESEARCH = SET_OE_CATEGORY_RESEARCH;
var RESET_RESEARCH = "RESET_RESEARCH";
exports.RESET_RESEARCH = RESET_RESEARCH;
var SET_FILTERS = "SET_FILTERS";
exports.SET_FILTERS = SET_FILTERS;
var SET_SELECTED_ITEMS_AND_EXTERNAL_INFO = "SET_SELECTED_ITEMS_AND_EXTERNAL_INFO";
exports.SET_SELECTED_ITEMS_AND_EXTERNAL_INFO = SET_SELECTED_ITEMS_AND_EXTERNAL_INFO;